export default __webpack_public_path__ + "bfdd50579510c6271e64cb01a40067ce.png";